import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from "@angular/core";

import { CardViewModel } from "../../models/card.vm";
import { RouterModule } from "@angular/router";
import { CardBoxComponent } from "../card-box/card-box.component";
import { ViewTransitionSourceDirective } from "@upupa/common";
import { listAnimation } from "../../animations";

@Component({
    selector: "in2-blog-list",
    imports: [RouterModule, CardBoxComponent, ViewTransitionSourceDirective],
    templateUrl: "./blogs-list.component.html",
    styleUrls: ["./blogs-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [listAnimation],
    host: {
        "[@listAnimation]": "blogList().length",
    },
})
export class BlogListComponent {
    cardClassList = input("animated in2-list-item");
    blogList = input.required({
        transform: (v: CardViewModel[]) => {
            const arr = (v ?? []).filter((c) => c);
            return arr.map(
                (c) =>
                    ({
                        ...c,
                        meta: { type: "article", ...c.meta },
                    }) as CardViewModel,
            );
        },
    });

    @Output() cardClick = new EventEmitter<CardViewModel>();

    getCardClassList(item: CardViewModel) {
        return this.cardClassList() + " " + (item.meta?.classList ?? "");
    }
}
